<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable && selectedOrganization.active">
      <v-btn
        v-if="createAll || (canCreate && userData.timesheet_tracking)"
        class="floating-add-button"
        color="#64CA7F"
        elevation="0"
        fab
        @click="showCreateModal = true"
      >
        <v-icon color="#ffffff">
          mdi-table-large-plus
        </v-icon>
      </v-btn>
    </div>
    <div v-if="anyUserOrganizationsAvailable">
      <v-row class="mt-4 justify-center align-start">
        <v-col
          cols="8"
          class="text-right"
        >
          <v-select
            v-model="project"
            light
            color="#37474F"
            flat
            dense
            :items="projectsList"
            item-text="name"
            item-value="id"
            label="Project"
            outlined
            class="small-select"
            @change="fetchData"
          />
        </v-col>
        <v-col cols="2">
          <v-btn
            color="#FFFFFF"
            outlined
            class="next-style"
            elevation="0"
            @click="showFilterDialog = true"
          >
            Filter
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-btn
            dark
            fab
            outlined
            icon
            color="#37474F"
            small
            @click="clearFilter()"
          >
            <v-icon
              small
              dark
            >
              mdi-filter-off
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div>
        <v-card
          small
          color="transparent"
          class="project-card"
          elevation="0"
        >
          <v-row>
            <v-col>
              <div
                v-if="shouldShowEmptyState"
                class="empty-alert-div"
              >
                <v-card
                  color="#FFF"
                  elevation="0"
                >
                  <br>
                  <br>
                  <p class="empty-alert-msg">
                    <v-icon
                      size="25"
                      color="#C62828"
                    >
                      mdi-information-outline
                    </v-icon>
                    No Timesheets Found
                  </p>
                  <br>
                  <br>
                </v-card>
              </div>
              <div
                v-else
                class="container-box"
              >
                <div
                  v-for="item in timesheets"
                  :key="item.id"
                  class="box mb-3"
                  @click="showEditDialog(item.id)"
                >
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                        class="d-flex justify-space-between"
                      >
                        <div>
                          <div v-if="createAll || viewAll">
                            <span><font
                              v-if="item.app_user_organization !== null"
                            >{{ item.app_user_organization.first_name }}
                              {{ item.app_user_organization.last_name }}</font><font v-else>N/A</font></span>
                          </div>
                          <p v-if="createAll">
                            {{ item.project.name }}
                          </p>
                          <span
                            v-else
                          ><span>{{ item.project.name }}</span></span>
                          <span class="value-text-style d-flex align-center">
                            <v-icon
                              size="18"
                              color="#FF7E67"
                              class="mr-1"
                            >mdi mdi-calendar-blank-outline</v-icon>
                            <span><span>{{
                              item.start_time | convertToLocal
                            }}</span>
                            </span>
                          </span>
                          <span class="value-text-style">
                            <v-icon
                              size="18"
                              color="#64CA7F"
                            >mdi mdi-clock-outline</v-icon>
                            {{ item.worked_hour }} Hrs
                          </span>
                        </div>
                        <div class="text-right">
                          <span class="value-text-style">
                            {{ item.pay_item.name | formatTimeType }}
                          </span>
                          <br>
                          <span class="value-text-style">
                            <font :color="getStatusColor(item.status)">
                              {{ item.status | formatTimeType }}
                            </font>
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                    <div
                      v-if="
                        item.status === 'pending' &&
                          organizationSettings.require_time_approval &&
                          isTimeApprovalEnabled && selectedOrganization.active
                      "
                    >
                      <div class="verification-btn-group">
                        <v-btn
                          small
                          color="red"
                          elevation="0"
                          @click.stop
                          @click="declineTimesheet(item.id)"
                        >
                          Decline
                        </v-btn>
                        <v-btn
                          small
                          color="green"
                          elevation="0"
                          @click.stop
                          @click="acceptTimesheet(item.id)"
                        >
                          Verify
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </div>
                <div
                  ref="observer"
                  class="observer"
                />
                <div class="text-center">
                  <v-btn
                    v-if="!lazyLoader"
                    class="load-more-btn"
                    small
                    fab
                    elevation="0"
                    color="#37474F"
                    outlined
                    @click="fetchData"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </div>
                <div class="text-center">
                  <v-progress-circular
                    v-if="lazyLoader"
                    size="25"
                    :width="1"
                    color="#E2E2E2"
                    indeterminate
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-5"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <timesheet-edit
      v-if="showModal"
      :timesheet-id="timesheetId"
      @timesheet-updated="fetchData"
      @timesheet-deleted="fetchData"
      @closed="showModal = false"
    />
    <timesheet-filter
      v-if="showFilterDialog"
      :filter-from="'all'"
      :filter-stored-data="allFilterData"
      @filtered-data="filterTimesheets"
      @remove-all-filter-property="
        day = null;
        week = null;
        month = null;
        dataFiltered = undefined;
      "
      @closed="showFilterDialog = false"
      @clearedFormFilters="(startDate = null), (endDate = null)"
    />
    <centre-spinner :loading="loading" />
    <timesheet-create
      v-if="showCreateModal"
      @timesheet-created="fetchData"
      @closed="showCreateModal = false"
    />
    <alert-dialog
      v-if="showAlertDialog"
      :title="title"
      :message="message"
      @closed="showAlertDialog = false"
      @confirmed="verifyTimesheet"
    />
  </div>
</template>
<script>
import TimesheetEdit from './TimesheetEdit.vue';
import TimesheetFilter from './TimesheetFilter.vue';
import TimesheetCreate from './TimesheetCreate.vue';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
import Constants from 'src/constants';
import AlertDialog from '../../../../components/AlertDialog.vue';

export default {
  name: 'TimesheetAll',
  components: {
    'centre-spinner': spinner,
    'timesheet-edit': TimesheetEdit,
    'timesheet-filter': TimesheetFilter,
    'timesheet-create': TimesheetCreate,
    'alert-dialog': AlertDialog,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    statusUpdate (val) {
      if (val === true) {
        return 'Active*';
      }
      return 'Expired';
    },
    convertToLocal (stringDatetime) {
      return moment.utc(stringDatetime).local().format('Do MMMM YYYY');
    },
    formatTimeType (type) {
      if (!type) return '';
      return type.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    },
  },
  data: () => ({
    loading: false,
    showCreateModal: false,
    lazyLoader: false,
    startPage: 0,
    observer: null,
    showModal: false,
    timesheetId: '',
    showFilterDialog: false,
    startDate: null,
    endDate: null,
    day: null,
    week: null,
    month: null,
    project: null,
    dataFiltered: undefined,
    canCreate: false,
    createAll: false,
    canView: false,
    viewAll: false,
    isTimeApprovalEnabled: false,
    showAlertDialog: false,
    title: '',
    message: '',
    permission: '',
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    organizationSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    anyUserOrganizationsAvailable () {
      if (this.userOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    timesheets () {
      return this.$store.getters['timesheets/getAllTimesheets'];
    },
    shouldShowEmptyState () {
      return (
        this.timesheets.length === 0 ||
        (this.viewAll === false && this.canView === false)
      );
    },
    allFilterData () {
      return this.$store.getters['timesheets/getAllFilterData'];
    },
    projectsList () {
      return this.$store.getters['projects/getOrganizationProjects'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    this.$store.dispatch('timesheets/clearAllData');
    await this.getUserOrganizations();

    if (this.anyUserOrganizationsAvailable) {
      await this.fetchProjects();
      this.checkTimesheetPermissions();
      await this.fetchAllTimesheets();
      await this.loadMore();
    }

    this.loading = false;
  },
  methods: {
    checkTimesheetPermissions () {
      const role = this.selectedOrganization.app_user_role;
      const allPermissions = this.organizationSettings.timesheet_permissions;
      const timeApproval = this.organizationSettings.time_approval;
      const isTimeApprovalEnabled = timeApproval.some(
        (item) => item.id === role,
      );
      let rolePer = null;

      if (allPermissions !== null) {
        switch (role) {
          case 'site-manager':
            rolePer = allPermissions.site_manager;
            break;
          case 'worker':
            rolePer = allPermissions.worker;
            break;
          case 'contractor':
            rolePer = allPermissions.contractor;
            break;
        }
      }
      this.canCreate = rolePer.create.own || rolePer.create.all;
      this.createAll = rolePer.create.all;
      this.viewAll = rolePer.view.all;
      this.canView = rolePer.view.own;
      this.isTimeApprovalEnabled = isTimeApprovalEnabled;
      return rolePer;
    },
    declineTimesheet (id) {
      this.showAlertDialog = true;
      this.title = 'Decline Timsheet?';
      this.message = 'This action is permanent and cannot be undone.';
      this.permission = 'declined';
      this.timesheetId = id;
    },
    acceptTimesheet (id) {
      this.showAlertDialog = true;
      this.title = 'Verify Timsheet?';
      this.message = 'This action is permanent and cannot be undone.';
      this.permission = 'time-verified';
      this.timesheetId = id;
    },
    async verifyTimesheet () {
      this.loading = true;
      const orgExtId = await this.selectedOrganization.organization.external_id;
      await this.$store.dispatch('timesheets/updateTimesheetPermission', {
        orgExtId: orgExtId,
        data: {
          timesheets: [this.timesheetId],
          status: this.permission,
        },
      });
      this.showAlertDialog = false;
      this.startPage = 0;
      this.$store.dispatch('timesheets/clearAllData');
      await this.fetchAllTimesheets(this.dataFiltered);
      this.$store.dispatch(
        'alert/onAlert',
        {
          message:
            this.permission === 'declined'
              ? 'Timesheet declined successfully!'
              : 'Timesheet verified successfully!',
          type: Constants.ALERT_TYPE_SUCCESS,
        },
        { root: true },
      );
      await this.loadMore();
      this.loading = false;
    },

    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      });
    },
    getColor (val) {
      if (val === 'active') {
        return '#2E7D32';
      }
      return '#C62828';
    },
    async fetchProjects () {
      const orgExtId = await this.selectedOrganization.organization.external_id;
      await this.$store.dispatch('projects/fetchOrganizationProjects', {
        organizationExtId: orgExtId,
      });
    },
    getUTCStartDateRangeFromLocalDate (localDate) {
      const fromStart = localDate
        ? moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
            .utc()
            .format()
        : '';
      const fromEnd = localDate
        ? moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
            .utc()
            .format()
        : '';
      return { fromStart, fromEnd };
    },
    getUTCEndDateRangeFromLocalDate (localDate) {
      const toStart = localDate
        ? moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
            .utc()
            .format()
        : '';
      const toEnd = localDate
        ? moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
            .utc()
            .format()
        : '';
      return { toStart, toEnd };
    },
    getUTCDateRangeFromLocalDate (localDate) {
      const start = moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format();
      const end = moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format();
      return { start, end };
    },
    async fetchAllTimesheets (filterData) {
      this.lazyLoader = true;
      if (filterData !== undefined) {
        if (filterData.date_type === 'today') {
          const { start, end } = this.getUTCDateRangeFromLocalDate(
            moment().format('YYYY-MM-DD'),
          );
          this.week = null;
          this.month = null;
          this.startDate = start;
          this.endDate = end;
        }
        if (filterData.date_type === 'yesterday') {
          const { start, end } = this.getUTCDateRangeFromLocalDate(
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          );
          this.week = null;
          this.month = null;
          this.startDate = start;
          this.endDate = end;
        }
        if (filterData.date_type === 'week') {
          this.startDate = moment()
            .subtract(6, 'days')
            .startOf('day')
            .utc()
            .format();
          this.endDate = moment().endOf('day').utc().format();
        }

        if (filterData.date_type === 'this_month') {
          this.startDate = moment().startOf('month').utc().format();
          this.endDate = moment().endOf('month').utc().format();
        }

        if (filterData.date_type === 'last_month') {
          this.startDate = moment()
            .subtract(1, 'month')
            .startOf('month')
            .utc()
            .format();
          this.endDate = moment()
            .subtract(1, 'month')
            .endOf('month')
            .utc()
            .format();
        }
      }

      const hasStart =
        filterData === undefined ? null : !!filterData.start_date;
      const hasEnd = filterData === undefined ? null : !!filterData.end_date;

      const { fromStart, fromEnd } = this.getUTCStartDateRangeFromLocalDate(
        hasStart ? filterData.start_date : moment().format('YYYY-MM-DD'),
      );
      const { toStart, toEnd } = this.getUTCEndDateRangeFromLocalDate(
        hasEnd ? filterData.end_date : moment().format('YYYY-MM-DD'),
      );

      let from = null;
      let to = null;
      if (hasStart && !hasEnd) {
        from = fromStart;
        to = fromEnd;
      } else if (hasStart && hasEnd) {
        from = fromStart;
        to = toEnd;
      } else if (!hasStart && hasEnd) {
        from = toStart;
        to = toEnd;
      }

      const extId = this.selectedOrganization.organization.external_id;
      await this.$store
        .dispatch('timesheets/fetchAllTimesheets', {
          orgExtId: extId,
          params: {
            params: {
              limit: 5,
              startPage: this.startPage,
              status: ['pending', 'declined', 'approved', 'time-verified'],
              payItemId: filterData !== undefined ? filterData.type : null,
              from:
                this.startDate !== null
                  ? this.startDate
                  : filterData !== undefined
                  ? from
                  : null,
              to:
                this.endDate !== null
                  ? this.endDate
                  : filterData !== undefined
                  ? (hasStart && !hasEnd ? null : to)
                  : null,
              project: this.project !== null ? this.project : null,
              appUserOrganization:
                filterData !== undefined ? filterData.app_user : null,
            },
          },
        })
        .then(() => {
          this.startPage += 5;
          this.lazyLoader = false;
          this.this.loadMore();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async clearFilter () {
      this.startPage = 0;
      this.week = null;
      this.startDate = null;
      this.endDate = null;
      this.month = null;
      this.project = null;
      this.dataFiltered = undefined;
      this.$store.dispatch('timesheets/clearAllData');
      this.$store.dispatch('timesheets/storeTimesheetAllFilterData', null);
      await this.fetchAllTimesheets();
      await this.loadMore();
    },
    async loadMore () {
      if (this.timesheets.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.fetchAllTimesheets(this.dataFiltered);
      }
    },
    async filteredData () {
      this.startPage = 0;
      await this.loadMore();
    },
    showEditDialog (id) {
      this.timesheetId = id;
      this.showModal = true;
    },
    async filterTimesheets (data) {
      this.dataFiltered = data;
      this.startPage = 0;
      this.$store.dispatch('timesheets/storeTimesheetAllFilterData', data);
      this.$store.dispatch('timesheets/clearAllData');
      await this.fetchAllTimesheets(this.dataFiltered);
      await this.loadMore();
    },
    async fetchData () {
      this.loading = true;
      this.startPage = 0;
      this.$store.dispatch('timesheets/clearAllData');
      this.$nextTick;
      await this.fetchAllTimesheets(this.dataFiltered);
      await this.loadMore();
      this.loading = false;
    },
    getStatusColor (val) {
      if (val === 'approved' || val === 'time-verified') {
        return '#2E7D32';
      } else if (val === 'pending') {
        return '#C62828';
      } else {
        return '#ff0000';
      }
    },
  },
};
</script>

<style scoped>
.time-style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
}

p {
  margin-bottom: 0px !important;
}

.box {
  /* padding-bottom: 7px; */
  width: 100% !important;
  border-radius: 10px;
  background: #fff;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.v-progress-circular {
  margin: 1rem;
}

.text-white {
  color: white;
}

.rounded {
  border-radius: 10px !important;
}

.subheader-style {
  font-size: 14px;
}

.title-text {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
}

.value-text-style {
  font-size: 12px;
}

.project-card {
  border-radius: 0px !important;
  padding: 0px !important;
}

.btn-sm {
  height: 20px !important;
}

.short-letter-style {
  color: white;
}

.observer {
  height: 40px;
}

.col-2 {
  padding-right: 0px;
  padding-left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-3 {
  padding-right: 0px;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.date-style {
  font-weight: 500;
}

.status-style {
  font-weight: 500;
  text-transform: capitalize;
}

.money-style {
  color: green;
  font-weight: bold;
}

.next-style {
  font-size: 12px;
  width: 80px;
  padding: 0px;
  margin: 0px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.filter-style {
  text-align: right;
  padding-top: 10px;
  padding-bottom: 10px;
}

.more-btn {
  border: none !important;
  padding-top: 0px;
}

.empty-alert-msg {
  padding: 12px;
}

.v-card__actions {
  justify-content: flex-end !important;
}

hr {
  border-color: #cccccc3d;
}

.floating-add-button {
  position: fixed;
  bottom: 70px !important;
  right: 10px;
  z-index: 1;
}

.verification-btn-group {
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 10px;
}
</style>
